
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface CloseOnboardingRequest {
    accountId: string;
}

/**
 * 
 */
export class OnboardingFixturesApi extends runtime.BaseAPI {

    /**
          */
    async closeOnboardingRaw(requestParameters: CloseOnboardingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling closeOnboarding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/test-fixtures/onboarding/{accountId}`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async closeOnboarding(requestParameters: CloseOnboardingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.closeOnboardingRaw(requestParameters, initOverrides);
    }

}
